// Central API base URLs.
//
// When CORE-THEME runs standalone (npm run dev), the values come from
// src/services/.env (Vite VITE_* vars, baked in at build time).
//
// When CORE-THEME is consumed as the published @realtek/core-theme package,
// those build-time values are frozen to whatever CORE-THEME was built with —
// which is NOT what every host app wants. So the host app can override them at
// RUNTIME by setting `window.__CORE_THEME_CONFIG__` BEFORE the app bundle loads
// (put the <script> in the host's index.html, above the module script):
//
//   <script>
//     window.__CORE_THEME_CONFIG__ = {
//       VITE_AUTH_URL:        'http://192.168.1.66/authapi/v1',
//       VITE_SUBMISSIONS_URL: 'http://192.168.1.66/submissionsapi/v1',
//       VITE_JOBS_URL:        'http://192.168.1.66/jobsapi/v1',
//       VITE_CANDIDATES_URL:  'http://192.168.1.66/candidatesapi/v1',
//     };
//   </script>
//
// Priority: runtime window config  >  build-time .env fallback.

const BUILD_TIME_FALLBACK = {
  VITE_AUTH_URL: import.meta.env.VITE_AUTH_URL,
  VITE_ADMIN_API_URL: import.meta.env.VITE_ADMIN_API_URL,
  VITE_ADMIN_APP_ID: import.meta.env.VITE_ADMIN_APP_ID,
  VITE_SUBMISSIONS_URL: import.meta.env.VITE_SUBMISSIONS_URL,
  VITE_JOBS_URL: import.meta.env.VITE_JOBS_URL,
  VITE_CANDIDATES_URL: import.meta.env.VITE_CANDIDATES_URL,
};

function resolve(key) {
  if (
    typeof window !== 'undefined' &&
    window.__CORE_THEME_CONFIG__ &&
    window.__CORE_THEME_CONFIG__[key] != null
  ) {
    return window.__CORE_THEME_CONFIG__[key];
  }
  return BUILD_TIME_FALLBACK[key];
}

export const AUTH_URL = resolve('VITE_AUTH_URL');
export const ADMIN_API_URL = resolve('VITE_ADMIN_API_URL') || 'http://localhost:9009';
export const ADMIN_APP_ID = resolve('VITE_ADMIN_APP_ID') || 'zinnext-dev-api-v1';
export const SUBMISSIONS_URL = resolve('VITE_SUBMISSIONS_URL');
export const JOBS_URL = resolve('VITE_JOBS_URL');
export const CANDIDATES_URL = resolve('VITE_CANDIDATES_URL');

// Optional JS helper (alternative to the index.html <script>). Because the
// exports above are resolved when this module first loads, call this BEFORE the
// first import of @realtek/core-theme — e.g. in the host's index.html, not in
// main.jsx (which runs after imports are evaluated). The index.html <script>
// approach is the reliable one.
export function configureCoreTheme(config = {}) {
  if (typeof window === 'undefined') return;
  window.__CORE_THEME_CONFIG__ = { ...(window.__CORE_THEME_CONFIG__ || {}), ...config };
}
